import Config from "./Config";
import * as msal from "@azure/msal-browser";
import { DialogUtility } from '@syncfusion/ej2-popups';

const key = "AuthenticationResult";
const loginRequest = { scopes: [`${Config.Provider("auth").clientId}/.default`] };
const msalInstance = new msal.PublicClientApplication({ auth: Config.Provider("auth") });


const Session = {
    IsAuthenticated: () => {
        var auth = JSON.parse(localStorage.getItem(key));

        if (auth === null) {
            return false;
        }

        var expires = new Date(auth.expiresOn);
        var now = new Date();

        if (now >= expires) {
            return false;
        }

        return true;
    },
    SetAuthenticationResult: (auth) => {
        localStorage.setItem(key, JSON.stringify(auth));
    },
    GetAuthenticationToken: () => {
        var auth = JSON.parse(localStorage.getItem(key));

        if (auth === null) {
            return null;
        }

        return auth.accessToken;
    },
    GetDisplayName: () => {
        var auth = JSON.parse(localStorage.getItem(key));

        if (auth === null) {
            return null;
        }

        return auth.account.name;
    },
    GetUserName: () => {
        var auth = JSON.parse(localStorage.getItem(key));

        if (auth === null) {
            return null;
        }

        return auth.account.username;
    },
    DisplayError: () => {
        let html = document.createElement('div');

        html.innerHTML += `<div><h4>Unable to determine NCAS Reporting Access. Please refresh and try again. If issues persist please contact a system administrator for access.</h4></div>`

        DialogUtility.alert({
            title: `Access Denied`,
            content: html,
            okButton: { cssClass: 'hidden' },
            showCloseIcon: false,
            closeOnEscape: false,
            animationSettings: { effect: 'Zoom' }
        });
    },
    WaitToBeAuthenticated: (func) => {
        let counter = 0;
        let authenticating = false;
        let interval = setInterval(() => {
            if (Session.IsAuthenticated() === true) {
                func();

                clearInterval(interval);
            }

            if (authenticating === false && Session.IsAuthenticated() === false) {
                msalInstance.loginPopup(loginRequest)
                    .then((response) => {
                        Session.SetAuthenticationResult(response);
                    })
                    .catch(() => {
                        Session.DisplayError();
                    });

                authenticating = true;
            }

            if (counter >= 100) {
                clearInterval(interval);
            }

            counter += 1;
        }, 500);
    }
};

export default Session;